// SPDX-License-Identifier: AGPL-3.0-or-later

import type {TableGameLeague} from '@fluxer/constants/src/TableGameConstants';
import type {MessageDescriptor} from '@lingui/core';
import {msg} from '@lingui/core/macro';

export const TABLE_GAME_LEAGUE_DESCRIPTORS: Record<TableGameLeague, MessageDescriptor> = {
	bronze: msg({message: 'Bronze', comment: 'Table game leagues: the lowest league.'}),
	silver: msg({message: 'Silver', comment: 'Table game leagues: second league.'}),
	gold: msg({message: 'Gold', comment: 'Table game leagues: third league.'}),
	diamond: msg({message: 'Diamond', comment: 'Table game leagues: fourth league.'}),
	master: msg({message: 'Master', comment: 'Table game leagues: fifth league.'}),
	legend: msg({
		message: 'Legend',
		comment: 'Table game leagues: the top league, ranked by RR (rank rating) without a ceiling.',
	}),
};

export const LEADERBOARDS_DESCRIPTOR = msg({
	message: 'Leaderboards',
	comment: 'Table games: title of the leaderboards window and the button or menu item that opens it.',
});

export const RANKED_DESCRIPTOR = msg({
	message: 'Ranked',
	comment: 'Table games: marks a rated table; its result changes the players’ league and leaderboard place.',
});

export const RR_DESCRIPTOR = msg({
	message: '{rr} RR',
	comment: 'Table games: rank rating points in the Legend league. {rr} is a number. Keep RR as is.',
});

export const LEAGUE_PROGRESS_DESCRIPTOR = msg({
	message: '{percent}%',
	comment: 'Table games: progress toward the next league. {percent} is a whole number from 0 to 100.',
});

export const PLACEMENT_LEFT_DESCRIPTOR = msg({
	message: '{count, plural, one {# placement game left} other {# placement games left}}',
	comment: 'Table games: ranked games still needed before a league is given. {count} is a number.',
});

export const LEAGUE_OF_GAME_DESCRIPTOR = msg({
	message: '{game} · {league}',
	comment: 'Table games: a league in one game, for example "Chess · Gold".',
});

export const NO_RANKED_GAMES_DESCRIPTOR = msg({
	message: 'No ranked games yet',
	comment: 'Table game leaderboards: I have not played this game ranked.',
});

export const MY_RANK_DESCRIPTOR = msg({
	message: '#{rank}',
	comment: 'Table game leaderboards: my place on the board. {rank} is a number.',
});

export const GUILD_WEEK_ROW_DESCRIPTOR = msg({
	message: 'Leaderboards · this week',
	comment:
		'Table game leaderboards: the row at the top of a community’s channel list that opens its weekly points board.',
});

export const MY_WEEK_PLACE_DESCRIPTOR = msg({
	message: 'Your place this week: #{rank}',
	comment: 'Table game leaderboards: accessible label of my place on the weekly community board. {rank} is a number.',
});

export const SEE_ALL_DESCRIPTOR = msg({
	message: 'See all',
	comment: 'Table game leaderboards: link in the leaderboard card beside the feed that opens the leaderboards page.',
});

export const TOP_OF_GAME_DESCRIPTOR = msg({
	message: '{game} · top 3',
	comment:
		'Table game leaderboards: heading of the first three players of a game this season, for example "Chess · top 3".',
});

export const YOU_DESCRIPTOR = msg({
	message: 'You',
	comment: 'Table game leaderboards: tag beside my own name on the board.',
});

export const POINTS_DESCRIPTOR = msg({
	message: '{points, plural, one {# point} other {# points}}',
	comment: 'Table game leaderboards: weekly community points of a player. {points} is a number.',
});
